import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import GuardDutyDetailBody from '../GuardDutyDetailBody';

export const guarddutyEngine = {
  id: 'guardduty',
  label: 'GuardDuty',
  color: '#E65100',
  Icon: GppMaybeIcon,
  // NOTE: the card's copy (name/source/description/items) is served by the
  // BACKEND — EnableCapabilities reads `row.capability` from /capabilities and
  // falls back to `{}`, never to this file. A duplicate here was already drifting
  // from Go's Capability() on at least one engine, so it was removed rather than
  // left to be trusted. Change the copy in securityhub_engine_<id>.go.
  nav: [
    { label: 'Threats', to: '/securityhub/guardduty' },
    { label: 'Findings', to: '/securityhub/guardduty/findings' },
    { label: 'Enrollment', to: '/securityhub/guardduty/enrollment' },
    { label: 'Settings', to: '/securityhub/guardduty/settings' },
  ],
  enableRoute: '/securityhub/guardduty',
  DetailBody: GuardDutyDetailBody,
};
